import Vue from 'vue'
import Header from './header'
import MyButton from './button'
Vue.use(Header).use(MyButton)



// WEBPACK FOOTER //
// ./src/components/index.js